import api from "../auth/api";
import { useAuth } from "~/store/auth";

export default function checkDatafreeCap (){
	const auth = useAuth()
    
    if (auth.profile?.id) {
		api<{capped: boolean}>({
			url: "/Datafree/DataFreeUsageCapped",
			type: "api",
			options: {
				method: "GET",
				headers: {
					"x-accountId": auth.profile?.id,
				},
			},
		}).then((data) => {
			if (data.capped) {
				window.location.href = "/offers/data-free-cap";
			}
		});
	}
};